import { useMemo } from 'react';
import type { BoolStarFilterViewModel } from 'autogen/swagger/all';
import ButtonWithActiveState from 'components/Button/ButtonWithActiveState';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import { ActiveCount } from '../shared/styles';

export default function BooleanStarFilterMenuOpener({
    model: {
        displayName,
        options,
        isActive,
        attribute: { id }
    },
    ...restProps
}: {
    model: BoolStarFilterViewModel;
}) {
    const activeOptions = useMemo(() => options.filter((option) => option.isSelected).length, [options]);
    const filterMenuId = id.toString();
    const { openFilterMenu } = useFilterMenu(filterMenuId);

    return (
        <ButtonWithActiveState size="lg" isActive={isActive} onClick={openFilterMenu} {...restProps}>
            {displayName} {!!activeOptions && <ActiveCount>{activeOptions}</ActiveCount>}
        </ButtonWithActiveState>
    );
}
